import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18n } from 'aws-amplify';
import { submitOnchangeFormQA, submitOnchangeProject } from '../handler/QaTicketHandler';

export const DialogConfirmChangeDeskOrForm = (props) => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmChangeDeskOrForm(false);
    };

    const onHandlerConfirmChange = () => {
        if (props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.HELPDESK) {
            submitOnchangeProject(props.selectedProjectChange, props);
            props.setSelectedProjectChange('');
        } else if (props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.FORM) {
            submitOnchangeFormQA(props.selectedFormChange, props);
            props.setSelectedFormChange('');
        }

        props.setIsConfirmChangeDeskOrForm(false);
        props?.clearErrors();
    }

    return (
        <Dialog
            open={props.isConfirmChangeDeskOrForm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.HELPDESK ? I18n.get('USER04MSG016') : I18n.get('USER04MSG017')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onHandlerConfirmChange(props)}
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
